import React, { useEffect, useState } from "react";
import { ReactComponent as UpDownIcon } from "../../assets/icons/filter/updown.svg";
import { ReactComponent as LinkIcon } from "../../assets/icons/table/link.svg";
import { IProduct } from "../../types/product.type";
import styles from "./styles.module.scss";

interface Props {
  products: IProduct[];
  onPressLink: (id: string | number) => void;
}

const ExpiringProductsTable: React.FC<Props> = (props) => {
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    setProducts(
      props.products.sort(
        (a, b) =>
          a.batches.reduce((acc, item) => (acc += item.batchQuantity), 0) -
          b.batches.reduce((acc, item) => (acc += item.batchQuantity), 0)
      )
    );
  }, [props.products]);

  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Product</th>
          <th>Brand</th>
          <th>Capacity</th>
          <th>Price</th>
          <th>
            <button
              className={styles.opacityButton}
              onClick={() => {
                setProducts((prevState) => [...prevState].reverse());
              }}
            >
              Quantity
              <UpDownIcon className={styles.updown} />
            </button>
          </th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {products &&
          products.map((product, index) => (
            <tr key={product.id}>
              <td>
                <div className={styles.userInfo}>
                  {product.previewImageUrl ? (
                    <img
                      src={product.previewImageUrl}
                      className={styles.avatar}
                      alt="Avatar"
                    />
                  ) : (
                    <div className={styles.avatarEmpty}></div>
                  )}
                  <div className={styles.nameContainer}>
                    <span className={styles.name}>{product.name}</span>
                  </div>
                </div>
              </td>
              <td className={styles.role}>{product.brand.name}</td>
              <td className={styles.role}>{product.capacity}</td>
              <td className={styles.role}>
                {product.price}/{product.wholeSalePrice}
              </td>
              <td className={styles.role}>
                {product.batches.reduce(
                  (acc, item) => (acc += item.batchQuantity),
                  0
                )}
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.onPressLink(product.id);
                    }}
                  >
                    <LinkIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ExpiringProductsTable;
